import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'app-reserve-met',
  imports: [ButtonModule,
    FontAwesomeModule,
    DialogModule
  ],
  templateUrl: './reserve-met.component.html',
  styleUrl: './reserve-met.component.scss'
})
export class ReserveMetComponent {

  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  faCheckCircle = faCheckCircle

  onClose() {
    this.close.emit();
  }

}
